import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, GroupsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.st = new SmartTable();
        this.samlAppLogo = window.env.urls.samlAppLogo;
    }

    unassign() {
        this.isSaving = true;
        this.GroupsResource
            .unassignGroupFromApplications(this.companyId, this.group.id, this.st.selectedIds)
            .then(() => this.$state.reload(this.$state.current))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.applications.unassigned'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/applications/group-applications.controller.js